import { DEFAULT_IMAGE_EXTENSION, DEFAULT_IMAGE_RESOLUTION_MAP } from "../../components/coobjects/ImageDropdown";
import { CoObjectAdvanced } from "../../components/interfaces/CoObject";

export const builtInNumberFormat = [
  { key: "1", text: "0" },
  { key: "2", text: "0.00" },
  { key: "3", text: "#,##0" },
  { key: "4", text: "#,##0.00" },
  { key: "11", text: "0.00E+00" },
  { key: "12", text: "# ?/?" },
  { key: "13", text: "# /" },
  { key: "37", text: "#,##0;-#,##0" },
  { key: "38", text: "#,##0;[Red]-#,##0" },
  { key: "39", text: "#,##0.00;-#,##0.00" },
  { key: "40", text: "#,##0.00;[Red]-#,##0.00" },
  { key: "41", text: "_ * #,##0_ ;_ * “_ ;_ @_" },
  { key: "43", text: "_ * #,##0.00_ ;_ * “??_ ;_ @_" },
  { key: "48", text: "##0.0E+00" },
  { key: "998", text: "#,##0," },
  { key: "999", text: "#,##0,," },
];

export const builtInPercentageFormat = [
  { key: "9", text: "0%" },
  { key: "10", text: "0.00%" },
];

export const builtInDateFormat = [
  { key: "14", text: "m/d/yy" },
  { key: "15", text: "d-mmm-yy" },
  { key: "16", text: "d-mmm" },
  { key: "17", text: "mmm-yy" },
  { key: "18", text: "h:mm AM/PM" },
  { key: "19", text: "h:mm:ss AM/PM" },
  { key: "20", text: "h:mm" },
  { key: "21", text: "h:mm:ss" },
  { key: "22", text: "m/d/yy h:mm" },
  { key: "45", text: "mm:ss" },
  { key: "46", text: "h :mm:ss" },
  { key: "47", text: "mm:ss.0" },
];

export const defaultFormatting: CoObjectAdvanced = {
  formatMetadata: {
    numberFormatValue: "37", //#,##0;-#,##0
    numberType: "Default",
    percentageFormatValue: "10", //0.00%
    percentageType: "Default",
    dateFormatValue: "14", //m/d/yy
    dateType: "Default",
    locale: null,
  },
  formatImage: {
    imageExtension: DEFAULT_IMAGE_EXTENSION,
    imageResolution: DEFAULT_IMAGE_RESOLUTION_MAP.get(DEFAULT_IMAGE_EXTENSION),
  },
};
